import { render, staticRenderFns } from "./AvailabilityCalendarReturn.vue?vue&type=template&id=5d35083a&scoped=true"
import script from "./AvailabilityCalendarReturn.vue?vue&type=script&lang=js"
export * from "./AvailabilityCalendarReturn.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityCalendarReturn.vue?vue&type=style&index=0&id=5d35083a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d35083a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d35083a')) {
      api.createRecord('5d35083a', component.options)
    } else {
      api.reload('5d35083a', component.options)
    }
    module.hot.accept("./AvailabilityCalendarReturn.vue?vue&type=template&id=5d35083a&scoped=true", function () {
      api.rerender('5d35083a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialist-availability-calendar/components/availability-calendar/AvailabilityCalendarReturn.vue"
export default component.exports